<button
    type="button"
    class="tierliste-menu-trigger"
    (click)="$event.stopPropagation()"
    (mouseenter)="onTriggerHover()"
    [matMenuTriggerFor]="tierlisteMenu"
    [disabled]="menuDisabled || !tierlisteId"
    mat-icon-button
    aria-label="Tierlistenmenü"
>
    <mat-icon color="accent">more_vert</mat-icon>
</button>
<mat-menu #tierlisteMenu="matMenu">
    <ng-container *ngIf="menuReady || listenstatusId != null || isScansFortsetzenMode; else menuLoading">
        <ng-container *ngIf="isAusstallenMode">
            <button (click)="scansFortsetzen()" [disabled]="scansFortsetzenDisabled || loading" mat-menu-item>
                <mat-icon color="accent">barcode_reader</mat-icon>
                Scans fortsetzen
            </button>
            <button (click)="listeAbschliessen()" [disabled]="scansFortsetzenDisabled || loading" mat-menu-item>
                <mat-icon color="accent">check_circle</mat-icon>
                Liste abschliessen
            </button>
            <button *ngIf="canTierlisteLoeschen" (click)="tierlisteLoeschen()" [disabled]="loading" mat-menu-item>
                <mat-icon color="accent">delete</mat-icon>
                Tierliste löschen
            </button>
            <button *ngIf="canDownload" (click)="downloadTierliste()" [disabled]="loading" mat-menu-item>
                <mat-icon color="accent">download</mat-icon>
                Download
            </button>
            <button *ngIf="canSchlachthofSenden" (click)="tierlisteAnSchlachthof()" [disabled]="loading" mat-menu-item>
                <mat-icon color="accent">attach_email</mat-icon>
                Liste an Schlachthof senden
            </button>
        </ng-container>
        <ng-container *ngIf="isAbgeschlossenMode">
            <button
                *ngIf="showWiederOeffnenMenuItem"
                (click)="tierlisteWiederOeffnen()"
                [disabled]="wiederOeffnenDisabled"
                mat-menu-item
            >
                <mat-icon color="accent">lock_reset</mat-icon>
                wieder öffnen
            </button>
            <button *ngIf="canDownload" (click)="downloadTierliste()" [disabled]="loading" mat-menu-item>
                <mat-icon color="accent">download</mat-icon>
                Download
            </button>
            <button *ngIf="canSchlachthofSenden" (click)="tierlisteAnSchlachthof()" [disabled]="loading" mat-menu-item>
                <mat-icon color="accent">attach_email</mat-icon>
                Liste an Schlachthof senden
            </button>
        </ng-container>
        <ng-container *ngIf="isImportierenMode">
            <button *ngIf="canImportieren" (click)="inGruppeImportieren()" [disabled]="loading" mat-menu-item>
                <mat-icon color="accent">input</mat-icon>
                In Gruppe importieren
            </button>
            <button *ngIf="canNichtImportieren" (click)="nichtImportieren()" [disabled]="loading" mat-menu-item>
                <mat-icon color="accent">delete</mat-icon>
                Löschen / Nicht importieren
            </button>
            <button *ngIf="canSchlachthofSenden" (click)="tierlisteAnSchlachthof()" [disabled]="loading" mat-menu-item>
                <mat-icon color="accent">attach_email</mat-icon>
                Liste an Schlachthof senden
            </button>
            <button *ngIf="canDownload" (click)="downloadTierliste()" [disabled]="loading" mat-menu-item>
                <mat-icon color="accent">download</mat-icon>
                Herunterladen der Tierliste
            </button>
        </ng-container>
        <ng-container *ngIf="isScansFortsetzenMode">
            <button (click)="onScansFortsetzen()" mat-menu-item>
                <mat-icon color="accent">barcode_reader</mat-icon>
                Scans fortsetzen
            </button>
            <button (click)="onListeAbschliessen()" mat-menu-item>
                <mat-icon color="accent">check_circle</mat-icon>
                Liste abschliessen
            </button>
        </ng-container>
    </ng-container>
    <ng-template #menuLoading>
        <button mat-menu-item disabled>
            <mat-icon color="accent">hourglass_empty</mat-icon>
            Laden...
        </button>
    </ng-template>
</mat-menu>
